/**
 * SEOListPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  TabContent,
  InputFormTable,
  DragAndDropFiles,
} from 'components';
import { Input, Button, Avatar } from 'antd';
import { PictureOutlined } from '@ant-design/icons';

const SEOListPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const form1 = [
    {
      label: '이름',
      required: true,
      form: [
        {
          input: <Input size="large" placeholder="내용을 입력해주세요" />,
          fullscreen: true,
          count: true,
          maxLength: 30,
        },
      ],
    },
    {
      label: '안내설명',
      form: [
        {
          input: (
            <Input.TextArea
              placeholder="내용을 입력해주세요"
              style={{ height: 98 }}
            />
          ),
          fullscreen: true,
          count: true,
          maxLength: 1000,
        },
      ],
    },
    {
      label: '페이지별 태그',
      form: [
        {
          input: <Input size="large" placeholder="내용을 입력해주세요" />,
          fullscreen: true,
        },
        {
          input: <Button size="large">경로추가</Button>,
        },
      ],
    },
  ];
  const form2 = [
    {
      label: '메타태그 추가',
      direction: 'column',
      form: [
        {
          input: (
            <Input
              size="large"
              value={'<meta name=”site-verification” content=코드 />'}
            />
          ),
          fullscreen: true,
        },
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="<meta name=”site-verification” content=코드 />"
                style={{ width: '100%' }}
              />
              <Button size="large">태그 추가</Button>
            </>
          ),
          fullscreen: true,
        },
      ],
    },
  ];
  const form3 = [
    {
      label: '페이지별 태그',
      direction: 'column',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="파일을 업로드해주세요"
                style={{ width: '100%' }}
              />
              <Button size="large">파일선택</Button>
            </>
          ),
          fullscreen: true,
        },
        {
          input: (
            <>
              <DragAndDropFiles accept="image/*">
                <h2 style={{ fontSize: 16, fontWeight: 600 }}>
                  여기로 이미지를 드래그해주세요
                </h2>
              </DragAndDropFiles>
            </>
          ),
          fullscreen: true,
        },
      ],
    },
    {
      label: '미리보기',
      form: [
        {
          input: (
            <>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <div>
                  <Avatar
                    shape="square"
                    icon={<PictureOutlined />}
                    size={100}
                    style={{ width: 200, borderRadius: 0 }}
                  />
                </div>
                <div style={{ border: '1px solid #E0E0E0', padding: 5 }}>
                  <h4>JM COFFEE</h4>
                  <p>제이엠 커피 입니다.</p>
                  <p>www.jmcoffee.com</p>
                </div>
              </div>
              <div style={{ display: 'flex' }}>
                <div>
                  <Avatar
                    shape="square"
                    icon={<PictureOutlined />}
                    size={163}
                    style={{ borderRadius: 0 }}
                  />
                </div>
                <div
                  style={{
                    border: '1px solid #E0E0E0',
                    padding: 5,
                    width: 200,
                  }}
                >
                  <h4>JM COFFEE</h4>
                  <p>제이엠 커피 입니다.</p>
                  <p>www.jmcoffee.com</p>
                </div>
              </div>
            </>
          ),
          fullscreen: true,
        },
      ],
    },
  ];

  const tabItems = [
    {
      label: `SEO태그 설정`,
      key: `tab_1`,
      children: (
        <div>
          <InputFormTable form={form1} />
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: 26,
            }}
          >
            <Button
              size="large"
              style={{
                ...styles.button,
                background: 'var(--primary-color)',
                color: '#FFFFFF',
              }}
            >
              저장
            </Button>
            <Button size="large" style={{ ...styles.button }}>
              초기화
            </Button>
          </div>
        </div>
      ),
    },
    {
      label: `메타태그 설정`,
      key: `tab_2`,
      children: (
        <div>
          <InputFormTable form={form2} />
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: 26,
            }}
          >
            <Button
              size="large"
              style={{
                ...styles.button,
                background: 'var(--primary-color)',
                color: '#FFFFFF',
              }}
            >
              저장
            </Button>
            <Button size="large" style={{ ...styles.button }}>
              초기화
            </Button>
          </div>
        </div>
      ),
    },
    {
      label: `공유이미지(OG) 설정`,
      key: `tab_3`,
      children: (
        <div>
          <InputFormTable form={form3} />
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: 26,
            }}
          >
            <Button
              size="large"
              style={{
                ...styles.button,
                background: 'var(--primary-color)',
                color: '#FFFFFF',
              }}
            >
              저장
            </Button>
            <Button size="large" style={{ ...styles.button }}>
              초기화
            </Button>
          </div>
        </div>
      ),
    },
  ];

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>검색엔진 최적화</Title>

          {/* 정책목록 */}
          <Content maxWidth={'100%'} padding={20} borderRadius={4}>
            <TabContent items={tabItems} />
          </Content>
          {/* 정책목록 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default SEOListPresenter;
